import { motion } from "framer-motion";
import { FiArrowUpRight } from "react-icons/fi";

const RevealCards = () => {
    return (
        <section className="p-8 bg-cream">
            <h2 className="text-3xl font-semibold text-center mb-8 uppercase z-0 relative text-[10rem] text-black/10 pointer-events-none">
                Categorie
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-rows-3 lg:grid-cols-5 gap-4 max-w-4xl lg:max-w-full mx-auto lg:grid-flow-col">
                <div className="row-start-1 row-span-2">
                    <Card
                        title="MOBILIER HABITAT"
                        description="We make pretty buildings"
                        imgSrc="/assets/images/categories/MOBILIER HABITAT.jpg"
                        url="/categories/mobilier/habitat"
                    />
                </div>
                <div className="row-start-2 col-start-2 row-span-2">
                    <Card
                        title="MOBILIER PROFESSIONNEL"
                        description="This ones pretty nice"
                        imgSrc="/assets/images/categories/MOBILIER PROFESSIONNEL.jpg"
                        url="/categories/mobilier/professionnel"
                    />
                </div>
                <div className="row-start-2 col-start-3 row-span-2">
                    <Card
                        title="MOBILIER EXTÉRIEUR"
                        description="We can even do TALL buildings"
                        imgSrc="/assets/images/categories/MOBILIER EXTERIEUR.jpg"
                        url="/categories/mobilier/exterieur"
                    />
                </div>
                <div className="row-start-2 col-start-4 row-span-2">
                    <Card
                        title="LUMINAIRES & ACCESSOIRES"
                        description="You like wavy buildings?"
                        imgSrc="/assets/images/categories/LUMINAIRE & ACCESSOIRE.jpg"
                        url="/categories/objets-accessoires"
                    />
                </div>
                <div className="row-start-1 col-start-5 row-span-2">
                    <Card
                        title="NOS REALISATIONS"
                        description="This one's real blocky"
                        imgSrc="/assets/images/categories/NOS REALISATIONS.jpg"
                        url="/projects"
                    />
                </div>
            </div>
        </section>
    );
};

const Card = ({ imgSrc, title, description, url }) => {
    return (
        <motion.div whileHover="hover" className="w-full h-[300px] relative">
            <div className="h-1/2 p-6 flex flex-col justify-center bg-cocoa">
                <h3 className="text-xl mb-2 font-semibold text-white">{title}</h3>
                <p className="text-sm font-light text-slate-300">{description}</p>
            </div>
            <motion.div
                initial={{
                    top: "0%",
                    right: "0%"
                }}
                variants={{
                    hover: {
                        top: "50%",
                        right: "50%"
                    }
                }}
                className="absolute inset-0 bg-slate-200 z-10 group overflow-hidden"
            >
                <img
                    src={imgSrc}
                    alt={title}
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <motion.div
                        initial={{ opacity: 1 }}
                        whileHover={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="px-24 py-3 bg-white/30 backdrop-blur-sm rounded-lg flex items-center justify-center"
                    >
                        <motion.h2
                            className="text-2xl font-semibold text-white z-20 m-0 text-center whitespace-normal w-full"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.3, delay: 0.3 }}
                        >
                            {title}
                        </motion.h2>
                    </motion.div>
                </div>
            </motion.div>
            <a
                href={url}
                rel="nofollow"
                className="w-1/2 h-1/2 absolute bottom-0 right-0 z-0 grid place-content-center bg-white-beige text-black hover:text-brandy-rose transition-colors"
            >
                <div className="flex items-center">
                    <span className="text-xs">MORE</span>
                    <FiArrowUpRight className="text-lg" />
                </div>
            </a>
        </motion.div>
    );
};

export default RevealCards;